export default __webpack_public_path__ + "static/media/co2_red_light.813e17e1.svg";